export const en = {
	'На добавление': 'For addition',
	'На хранение': 'For storage',
	'На передачу': 'Transfer',
	'На отгрузку': 'For shipment',
	'На договор': 'For a contract',
	'На доп. услуги': 'For additional services'
};
